import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { Toaster } from "sonner";
import { Header, Footer } from "@/components/layout";
import { PageTransition, ColorblindFilters } from "@/components/common";
import { useAuth } from "@/features/auth";

export function App() {
  const location = useLocation();
  const { checkAuth } = useAuth();
  const isAdminCampaign = location.pathname.startsWith("/admin/campaigns");

  // Set HTML lang attribute for accessibility (backup for Helmet)
  useEffect(() => {
    document.documentElement.lang = "en-AU";
  }, []);

  // Check auth status on app mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <>
      {/* Set default HTML lang attribute for accessibility */}
      <Helmet htmlAttributes={{ lang: "en-AU" }} />
      <ColorblindFilters />
      {/* Skip to main content link for keyboard accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none focus:ring-2 focus:ring-accent"
      >
        Skip to main content
      </a>
      <div className="flex min-h-screen flex-col">
      <Header />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <AnimatePresence mode="wait">
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </AnimatePresence>
      </main>
      {!isAdminCampaign && <Footer />}
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "white",
            color: "hsl(var(--foreground))",
            border: "1px solid hsl(var(--border))",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
          },
        }}
      />
      </div>
    </>
  );
}
